// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1398":"a12eadd3501479ef","8189":"60e1cbbb0b866c0b","8819":"fd5b6c90464211bf"}[chunkId] + ".css";
};